module.exports = __webpack_public_path__ + "static/media/500004.cf15453d.svg";